import styled from 'styled-components'

type Props = {
  windowHeight?: number;
  loggedIn: boolean;
}

const StyledSideBar = styled.div<Props>`
  height: ${({ windowHeight }) => windowHeight}px;
  background-color: ${({ theme }) => theme.colors.background};
  width: 240px;
  overflow: hidden;
  position: sticky;
  display: grid;
  align-content: space-between;
  top: 0;
  z-index: ${({ theme }) => theme.elevations.fixed};
  overflow-y: auto;

  .sidebar-links {
    padding: 14px 6px;
    display: grid;
    grid-gap: 2px;

    .sidebar-link-group {
      label {
        padding: 0 11px;
        font-size: 13px;
        font-weight: 500;
        pointer-events: none;
        user-select: none;
        font-family: ${({ theme }) => theme.fonts.lexend};
        color: ${({ theme }) => theme.colors.gray[500]};
        margin: 14px 0 5px 0;
        letter-spacing: 0.02rem;
        display: block;
      }
    }
  }

  .sidebar-top,
  .sidebar-bottom {
    display: contents;
  }

  .sidebar-top {
    .sidebar-logo {
      padding: 20px 20px 0 20px;
    }

    .sidebar-links {
      padding-bottom: 0;
    }
  }

  .sidebar-menu {
    position: sticky;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.background};
    border-top: 1px solid ${({ theme }) => theme.colors.gray[200]};
  }

  .sidebar-user-links {
    display: grid;
    padding: 6px 6px 0 6px;

    a {
      padding: 7px;
      color: ${({ theme }) => theme.colors.gray[600]};
      font-size: 14px;
      font-weight: 600;
      background-color: ${({ theme }) => theme.colors.background};
      border-radius: 6px;
      transition: 0.2s;
      display: flex;
      align-items: center;

      svg {
        height: 18px;
        width: 18px;
        margin-right: 8px;
      }

      &:hover:not(.active) {
        background-color: ${({ theme }) => theme.colors.gray[100]};
      }

      &.active {
        background-color: ${({ theme }) => theme.colors.green[50]};
        color: ${({ theme }) => theme.colors.green[500]};
      }
    }
  }

  .sidebar-bottom {
    .sidebar-links {
      padding-top: 0;
    }

    .sidebar-user-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      border: 0;
      width: 100%;
      transition: 0.2s;
      background-color: transparent;

      .sidebar-user {
        display: flex;
        align-items: center;

        .avatar {
          margin-right: 10px;
        }

        .sidebar-user-name {
          font-size: 15px;
          font-weight: 600;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          text-align: left;
          -webkit-box-orient: vertical;
          overflow: hidden;
          color: ${({ theme }) => theme.colors.gray[600]};
        }
      }

      svg {
        height: 20px;
        flex-shrink: 0;
        margin-left: 10px;
        color: ${({ theme }) => theme.colors.gray[300]};
      }

      &:hover {
        cursor: pointer;
        background-color: ${({ theme }) => theme.colors.gray[100]};
      }
    }
  }

  @media (min-height: 600px) {
    .sidebar-top,
    .sidebar-bottom {
      display: block;
    }
  }
`

export default StyledSideBar
